var _defs, _circle, _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew284({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 4.76,
    cy: 6.88,
    r: 2.35
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 1,
    y: 3.12,
    width: 7.51,
    height: 7.51
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10.76,12.81v-4h.44v4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M11.84,10.84a2.46,2.46,0,0,1,.45-1.58,1.41,1.41,0,0,1,1.13-.56,1.43,1.43,0,0,1,.8.25,1.73,1.73,0,0,1,.57.72A2.76,2.76,0,0,1,15,10.79a2.43,2.43,0,0,1-.41,1.46,1.4,1.4,0,0,1-2.35,0A2.38,2.38,0,0,1,11.84,10.84Zm.45,0A1.82,1.82,0,0,0,12.62,12a1,1,0,0,0,.8.41,1,1,0,0,0,.8-.42,1.91,1.91,0,0,0,.33-1.22,2.45,2.45,0,0,0-.17-.93,1,1,0,0,0-.39-.5.91.91,0,0,0-.57-.19,1,1,0,0,0-.81.41A2.13,2.13,0,0,0,12.29,10.85Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew284);
export default __webpack_public_path__ + "static/media/Symbolpack_New_284.f2fc8b7d917b02f4becb7178dfddaaa3.svg";
export { ForwardRef as ReactComponent };